import OnlyAdmin from 'components/guards/OnlyAdmin';
import CountAvailable from 'packages/lib/methods/ticketInventory/CountAvailable';
import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup, InputGroupAddon, UncontrolledDropdown } from 'reactstrap';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import MultiSelect from "@khanacademy/react-multi-select";


interface ITicketInventoryItemProps {
  data: ITicketInventoryData;
  onAdd: (payload: any) => void;
  onSubstract: (payload: any) => void;
  onDelete: (payload: any) => void;
  onDisable: (payload: any) => void;
  onEnable: (payload: any) => void;
  reloadOnSave: (updateNum: any, num: any) => undefined;
  type: string;
  currency: string;
  capacityRemaining: number;
  deletedUser?: boolean;
  ticketInventory?: any[];
  description?: string;
  users?: any[];
  fullView?: boolean;
}
interface ITicketInventoryData {
  _id: string;
  name: string;
  quantity: number;
  price: number;
  bought: number;
  activated: number;
  checkedIn: number;
  newName: string;
  nameChanged: boolean;
  nameDisabled: boolean;
  cancelled: number;
  enabled?: boolean;
  goOnSaleAfter?: string;
  promoterId?: string;
  accessibleTo?: string[];
  availableOnGeneralLink?: boolean;
}
export default class TicketInventoryItem extends React.Component<
  ITicketInventoryItemProps,
  { [label: string]: any }
  > {

  public state = {
    available: '',
    changed: false,
    nameChanged: false,
    newName: '',
    nameDisabled: false,
    nameError: false,
    oldVal: '',
    error: false,
    disabled: false,
    options: [],
    selected: [],
    checked: false
  }
  constructor(props) {
    super(props);
    this.changeQuantity = this.changeQuantity.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.sellAfter = this.sellAfter.bind(this);
    this.updateName = this.updateName.bind(this);
    this.changeName = this.changeName.bind(this);
    this.changeAllocatedTo = this.changeAllocatedTo.bind(this);
    this.onGeneralLinkVisibilityChange = this.onGeneralLinkVisibilityChange.bind(this);
  }

  // for available
  public changeQuantity(e: any) {
    this.setState({ available: e.target.value, changed: true })
  }

  // update available
  public changeValue(id: any) {
    this.setState({ disabled: true })
    fetchGraphQL(`
    mutation {
      ticketBank {
        updateAvailable(id:"${id}",available:"${this.state.available}")
      }
    }
    `).then(res => {
      if (res !== undefined && res !== null && res.ticketBank !== undefined && res.ticketBank !== null && res.ticketBank.updateAvailable !== undefined) {
        // IN THE FUTURE USE THESE --- NOT BEING USED CURRENTLY
        if (res.ticketBank.updateAvailable === true) {
          this.setState({ error: false })
          // call a function here that refreshes the ws stuff regardless
          this.props.reloadOnSave(Math.random(), 1);
        } else {
          this.setState({ error: true, disabled: false })
        }
      }
    })
  }

  // for name
  public changeName(e: any) {
    this.setState({ newName: e.target.value, nameChanged: true })
  }

  // update name
  public updateName() {
    if (this.state.newName === '') {
      return;
    } else {
      this.setState({ nameDisabled: true })
    }

    fetchGraphQL(`
      mutation {
        ticketBank {
          updateNameIfUnsold(updatedName:"${this.state.newName}",tbId:"${this.props.data._id}")
        }
    }
    `).then(res => {
      if (res !== undefined && res !== null && res.ticketBank !== undefined && res.ticketBank !== null && res.ticketBank.updateNameIfUnsold !== undefined) {
        if (res.ticketBank.updateNameIfUnsold === true) {
          this.setState({ nameError: false })
          this.props.reloadOnSave(Math.random(), 1);
        } else {
          this.setState({ nameError: true, nameDisabled: false })
        }
      }
    })
  }


  public onGeneralLinkVisibilityChange() {
    const newVal = !this.state.checked;
    fetchGraphQL(`
    mutation {
      ticketBank {
        changeAvailableOnGeneralLink(ticketBankId:"${this.props.data._id}",availableOnGeneralLink:${newVal})
      }
    }
    `).then(res => {
      if (res.ticketBank.changeAvailableOnGeneralLink) {
        this.setState({ checked: newVal })
      }
    })

  }

  public componentDidMount() {

    const options: any[] = []
    this.props.users!.map((item: any) => {
      options.push({
        label: item.name + ' ' + item.lastname + (item.email.includes('@isotope-referral-code.com') ? ' (referral link)' : ' (' + item.email + ')'),
        value: item.id
      })
    })
    const selected: string[] = []
    if (this.props.data.promoterId) {
      selected.push(this.props.data.promoterId)
    }
    if (this.props.data.accessibleTo) {
      this.props.data.accessibleTo.map(item => {
        if (!selected.includes(item)) {
          selected.push(item)
        }
      })
    }

    // const selected = [this.props.data.promoterId ? this.props.data.promoterId : undefined]
    const checked = this.props.data.availableOnGeneralLink ? true : false

    this.setState({
      oldVal: CountAvailable(this.props.data.quantity, this.props.data.activated, this.props.data.bought),
      available: CountAvailable(this.props.data.quantity, this.props.data.activated, this.props.data.bought),
      newName: this.props.data.name,
      options,
      selected,
      checked
    })
  }

  public changeAllocatedTo(selected: string[]) {

    fetchGraphQL(
      `
      mutation {
        ticketBank {
          setSelected(ticketBankId:"${this.props.data._id}",selectedPromoters:"${selected.length === 0 ? "[]" : selected.toString()}")
        }
      }
      `
    ).then(res => {
      if (res.ticketBank.setSelected) {
        this.setState({
          selected
        })
      }
    })
  }

  public sellAfter(item: any) {
    fetchGraphQL(`
    mutation {
      ticketBank {
        updateGoOnSaleAfter(selected:"${this.props.data._id}",precursor:"${item}")
      }
    }
    `).then(res => {
      this.props.reloadOnSave(Math.random(), 1);
    })
  }

  public render() {
    const {
      _id,
      name,
      price,
      quantity,
      activated,
      bought,
      checkedIn,
      // promoterId,
      // availableOnGeneralLink,
      // cancelled,
      enabled
    } = this.props.data;

    // let user = {
    //   name: '', lastname: ''
    // }
    // if (promoterId) {
    //   user = this.props!.users!.find((item: any) => {
    //     return item.id === promoterId
    //   })
    // }

    return (
      <tr className="sexyBlack" style={{ height: 'auto' }}>
        <td style={{ textAlign: 'center', justifyContent: 'center' }} data-label="Ticket Name">
          {
            bought === 0 && activated === 0 ?
              <div style={{ width: '100%' }}>
                <InputGroup>
                  <Input
                    type="text"
                    name="search"
                    id="search"
                    style={{
                      height: '27px',
                      textAlign: 'center',
                      border: (this.state.nameError) ? '1px solid #FF9B9B' : 'none',
                      backgroundColor: '#ebecf1'
                    }}
                    value={this.state.newName}
                    onChange={e => this.changeName(e)}
                  />
                  {
                    this.state.nameChanged
                      ?
                      <InputGroupAddon addonType="append" style={{ paddingLeft: '10px' }}>
                        <button
                          className="new-button-white-4"
                          onClick={(e) => {
                            this.updateName()
                          }}
                          style={{
                            border: 'none',
                            width: 'auto',
                            paddingRight: '3px',
                            paddingLeft: '3px',
                            borderRadius: '5px'
                          }}
                          disabled={this.state.nameDisabled}
                          id="confirm"
                        >
                          Confirm
                        </button>
                      </InputGroupAddon>
                      :
                      null
                  }
                </InputGroup>
              </div>
              :
              name
          }
          {
            this.props.description ?
              <div className='gray-text' style={{ fontSize: '11px' }}>
                {this.props.description}
              </div>
              : null
          }
        </td>
        <td style={{ textAlign: 'center' }} data-label="Price">
          {
            this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
          }
          {price && price > 0 ? (price / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0}
        </td>
        <td data-label="Available" style={{ textAlign: 'center', justifyContent: 'center' }}>

          {!enabled ?
            <div className='ipad-break mobile-buttons'><br /></div>
            : null}

          <div style={{ width: '100%' }}>
            <InputGroup>
              <Input
                type="text"
                name="search"
                id="search"
                style={{
                  height: '27px',
                  textAlign: 'center',
                  border: (this.state.error) ? '1px solid #FF9B9B' : 'none',
                  backgroundColor: '#ebecf1'
                }}
                value={Number(this.state.available) && Number(this.state.available) < 0 ? this.props.capacityRemaining : this.state.available}
                onChange={e => this.changeQuantity(e)}
              />
              {
                this.state.changed
                  ?
                  <InputGroupAddon addonType="append" style={{ paddingLeft: '10px' }}>
                    <button
                      className="new-button-white-4"
                      onClick={(e) => {
                        this.changeValue(_id)
                      }}
                      style={{
                        border: 'none',
                        width: 'auto',
                        paddingRight: '3px',
                        paddingLeft: '3px'
                      }}
                      disabled={this.state.disabled}
                      id="confirm"
                    >
                      Confirm
                </button>
                  </InputGroupAddon>
                  :
                  null
              }
            </InputGroup>
          </div>
        </td>
        <td style={{ textAlign: 'center' }} data-label="Bought">
          {bought}
        </td>
        {
          this.props.fullView ?
            <>
              {this.props.type === "private"
                ? <td style={{ textAlign: 'center' }} data-label="Activated">
                  {activated}
                </td>
                : <td style={{ textAlign: 'center' }} data-label="Activated">
                  -
              </td>}
              <OnlyAdmin>
                <td style={{ textAlign: 'center' }} data-label="Checked-In">
                  {checkedIn}
                </td>
              </OnlyAdmin>
              <td style={{ textAlign: 'center' }} data-label="Total">
                {quantity === -1 ? <span>(&infin;){this.props.capacityRemaining}</span> : quantity}
              </td>
            </> : null
        }
        <td style={{ textAlign: 'center', height: 'auto' }} data-label="General-Link">
          <MultiSelect
            // className="multiselect-dropdown"
            options={this.state.options}
            selected={this.state.selected}
            onSelectedChanged={selected => this.changeAllocatedTo(selected)}
            style={{ position: 'relative' }}
          />
        </td>
        <td style={{ textAlign: 'center' }} data-label="General-Link">
          <input type="checkbox" value="general-link" checked={
            this.state.checked
          }
            onChange={e => this.onGeneralLinkVisibilityChange()}
          />
        </td>
        {
          this.props.fullView ?
            (this.props.type === 'public' && this.props.ticketInventory !== undefined ?
              <td style={{ textAlign: 'center' }} data-label="Sell After">
                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="div"
                    caret={true}
                    data-toggle="dropdown"
                  >
                    {this.props.data.goOnSaleAfter ?
                      this.props.ticketInventory!.find(item => {
                        return item._id === this.props.data.goOnSaleAfter
                      }).name : '-'}
                  </DropdownToggle>
                  <DropdownMenu style={{ borderRadius: '30px' }}>
                    <DropdownItem key={'setToNull'} onClick={e => this.sellAfter('setToNull')}>-</DropdownItem>
                    {
                      this.props.ticketInventory!.map((item: any) => {
                        if (item._id !== _id) {
                          if (item.goOnSaleAfter === undefined || item.goOnSaleAfter !== _id) {
                            return <DropdownItem key={item._id} onClick={e => this.sellAfter(item._id)}>{item.name}</DropdownItem>
                          }
                        }
                      })
                    }
                  </DropdownMenu>
                </UncontrolledDropdown>
              </td>
              :
              <td style={{ textAlign: 'center' }} data-label="Sell After">
                -
            </td>)
            : null
        }
        <td style={{ textAlign: 'center' }} data-label="Actions">
          <ButtonGroup width="120px">
            {Number(this.state.available) === quantity ? (
              <button
                onClick={e => {
                  this.props.onDelete({ _id })
                }}
                className="new-button-white-4"
                style={{
                  border: 'none'
                }}
                id="delete"
              >
                DELETE
              </button>
            ) : null}
          </ButtonGroup>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ticketInventory/modules/TicketInventoryItem.tsx